export const infiniteLoaderIndent = 0;
